import { useMemo } from 'react';

export default function FeaturesSection() {
  const features = useMemo(() => [
    {
      id: 1,
      icon: 'ri-shield-flash-line',
      title: '匿名安全浏览',
      desc: '51暗网吃瓜采用高级隐私保护机制，您的每一次在线暗网吃瓜都完全匿名，浏览记录不留痕迹，让您放心观看51吃瓜在线各类视频内容。',
    },
    {
      id: 2,
      icon: 'ri-speed-up-line',
      title: '极速高清播放',
      desc: '所有51cg吃瓜视频均支持高清画质与流畅播放，无论是暗网吃瓜视频还是暗网吃瓜直播，都为您提供零卡顿的极致观看体验。',
    },
    {
      id: 3,
      icon: 'ri-timer-flash-line',
      title: '24小时持续更新',
      desc: '我们的内容团队全天候监控热点事件，确保51吃瓜视频在线资源实时更新，让您不错过任何一个吃瓜视频的精彩瞬间。',
    },
  ], []);

  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            为什么选择我们
          </h2>
          <p className="text-sm text-foreground-500 mt-3">三大核心优势，打造最佳吃瓜体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/70 text-center group hover:border-primary-300 transition-all duration-200"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-50 flex items-center justify-center mx-auto group-hover:bg-primary-100 transition-colors">
                <i className={`${feature.icon} text-2xl md:text-3xl text-primary-500`}></i>
              </div>
              <h3 className="text-lg font-bold font-heading text-foreground-800 mt-5">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 mt-3 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}